import React, { useState, useEffect,useMemo  } from "react";
import { CloseOutlined } from "@ant-design/icons";

import { Radio, Form, Input, message, Button, Select, Modal,  Flex,
  Progress } from "antd";
import CandidateAddModal from "../../CandidateAddModal";


import "./candidateProfileForm.scss";

import editIcon from "../../../assets/pencil.png";
import StackChart from "../../StackChart";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import { EDUCATION_OPTIONS, SUPPORTED_LOCATION } from "../../../helper/categoryconstants";
import { reasonForLeavingFilter, reasonForNotWorkingFilter } from "../../../helper/filterconstants";
import NuJobsSignedInFooter from "../nuJobsSignedInFooter";

export default function NuJobsCandidateProfileForm({ rid }) {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Are you sure you want to save your changes?");
  const [submittedValues, setSubmittedValues] = useState(null);
  const [currentExptype, setExptype] = useState("Experienced");
  const [isEditMode, setIsEditMode] = useState(false);
  const [notWorking, setNotWorking] = useState(false);
  const [formKey, setFormKey] = useState(1);
  const { myResumes,nuJobsUpdateCandidateProfile,nujobsGetMyResumes,isFresher,refreshProfile,nujobsResetRefreshProfile} = useNuJobDetailsStore();
  const selectedProfileResume = myResumes?.[0]?.myresume;

  const [totalExp, setTotalExp] = useState("");
  const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  function setExpTypeHandler(e) {
    setExptype(e.target.value);
  }  

  function convertToUnixTimestamp(dateStr) {
    const [day, month, year] = dateStr.split("/").map(Number);
    const date = new Date(year, month - 1, day);
    return Math.floor(date.getTime() / 1000);
  }
  
  const encodeApplicationJson = (values) => {
    let encodedJsonValues = {};
    //FSM to maintain the JD state
    encodedJsonValues.applicationstatus = "Processing";
    //get company details
    encodedJsonValues.qhoid = userData.nujoid;
    encodedJsonValues.version = "1.0";
    encodedJsonValues._id = "Not Needed Only Dummy";
    encodedJsonValues.isfresher = currentExptype=="Fresher"?true:false;

    //now fill the parameters
    encodedJsonValues.applicationid = {};
    encodedJsonValues.applicationid.aadharid = values.aadharnumber;

    //ids in resumre
    encodedJsonValues.personaldetail = {};
    encodedJsonValues.personaldetail.name = values.name;
    encodedJsonValues.personaldetail.email = values.email;
    encodedJsonValues.personaldetail.mobile = values.mobile;
    encodedJsonValues.personaldetail.aadharid = values.aadharnumber;
    encodedJsonValues.personaldetail.dob = values.dob;
    encodedJsonValues.personaldetail.gender = values.gender;
    encodedJsonValues.personaldetail.uan = values.uannumber;    
    
    encodedJsonValues.skilltags = values.skills
        encodedJsonValues.newemploymentdetails = {};
        encodedJsonValues.newemploymentdetails.preferredlocation = [];

        encodedJsonValues.newemploymentdetails.preferredlocation =
          values.preferredlocation;
        encodedJsonValues.newemploymentdetails.locationchangereason =
          values.locationchangereason;
        encodedJsonValues.newemploymentdetails.ectc = {};
        encodedJsonValues.newemploymentdetails.ectc.totalctc = parseFloat(
          values.ectc
        );
        encodedJsonValues.newemploymentdetails.ectc.ctcremarks = values.ctcremarks;
        encodedJsonValues.newemploymentdetails.payroll = values.payroll;
        encodedJsonValues.newemploymentdetails.relevantexp =
          parseFloat(values.relevantexperience);
        encodedJsonValues.newemploymentdetails.totalexp = parseFloat(values.totalexp);
        encodedJsonValues.newemploymentdetails.ectcoptions = values.ectcoptions;

        let newDate = getTimeNow();

        encodedJsonValues.interviewstatus = null;
        encodedJsonValues.selectionstatus = null;
        encodedJsonValues.skillsevalsatus = null;
        encodedJsonValues.testevalstatus = null;

        //now fill the parameters
        encodedJsonValues.employmentdetails = {};
        encodedJsonValues.employmentdetails.currentcompany = values.currentcompany;
        encodedJsonValues.employmentdetails.designation = values.designation;
        encodedJsonValues.employmentdetails.currentlocation =values.currentlocation;
        encodedJsonValues.employmentdetails.currentctc = {};
        encodedJsonValues.employmentdetails.currentctc.totalctc = parseFloat(
          values.currentctc
        );
        encodedJsonValues.employmentdetails.noticeperiod = {};
        encodedJsonValues.employmentdetails.noticeperiod.officialnp = parseInt(
          values.noticeperiod
        );

        encodedJsonValues.employmentdetails.noticeperiod.negotiableto =
           parseInt(values.negotiablenoticeperiod);
        encodedJsonValues.employmentdetails.noticeperiod.lwd = values.lwd;
        if ((values.lwd != "") && (values.lwd != undefined)){
          encodedJsonValues.employmentdetails.noticeperiod.lwdts =
            convertToUnixTimestamp(values.lwd);
        }

        encodedJsonValues.employmentdetails.noticeperiod.reason = values.reason;
        encodedJsonValues.employmentdetails.noticeperiod.reason = values.reason;
        encodedJsonValues.employmentdetails.jobcontinuity = values.jobcontinuity;
        if(encodedJsonValues.employmentdetails.jobcontinuity == "Not Working"){
              encodedJsonValues.employmentdetails.notworkingreason = values.notworkingreason;
        }else{
              encodedJsonValues.employmentdetails.notworkingreason ="NA"
        }
        encodedJsonValues.educationaldetail = {};
        encodedJsonValues.educationaldetail.maxdegree = values.maxdegree;
        encodedJsonValues.educationaldetail.stream = values.stream;
        encodedJsonValues.educationaldetail.college = values.college;
        encodedJsonValues.educationaldetail.percentage = values.percentage;
        encodedJsonValues.educationaldetail.passoutyear = values.passoutyear;


    return encodedJsonValues;
  };

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  const handleFormSubmit = (values) => {
    setSubmittedValues(values);
    setOpenConfirm(true);
  };

  const handleJobContinuity = (e) => {
    if (e.target.value == "Not Working") {
      setNotWorking(true);
    }else {
      setNotWorking(false);
    }
  };

    //init  
  const initView = (isFresher) =>{
      if(isFresher) {
        setExptype("Fresher")
      }else{
        setExptype("Experienced")
      }     
  }

  useEffect(() => {
      
      if(refreshProfile){
        nujobsResetRefreshProfile()
      }else{
        nujobsGetMyResumes(initView);
      }
  }, [refreshProfile]);

  const getExpType=() =>{
      if(isFresher) {
        return "Fresher"
      }else{
        return "Experienced"
      }   
  }
  const appvalues = {
    name: selectedProfileResume?.personaldetail.name,
    email: selectedProfileResume?.personaldetail.email,
    mobile: selectedProfileResume?.personaldetail.mobile,
    currentlocation: selectedProfileResume?.employmentdetails.currentlocation,
    maxdegree: selectedProfileResume?.educationaldetail.maxdegree,
    stream: selectedProfileResume?.educationaldetail.stream,
    college: selectedProfileResume?.educationaldetail.college,
    percentage: selectedProfileResume?.educationaldetail.percentage,
    passoutyear: selectedProfileResume?.educationaldetail.passoutyear,
    designation: selectedProfileResume?.employmentdetails.designation,
    totalexp: myResumes?.[0]?.newemploymentdetails.totalexp,
    currentcompany: selectedProfileResume?.employmentdetails.currentcompany,
    noticeperiod:
      selectedProfileResume?.employmentdetails.noticeperiod.officialnp == 1024
        ? ""
        : selectedProfileResume?.employmentdetails.noticeperiod.officialnp,
    negotiablenoticeperiod:
      selectedProfileResume?.employmentdetails.noticeperiod.negotiableto == 1024
        ? ""
        : selectedProfileResume?.employmentdetails.noticeperiod.negotiableto,
    lwd: selectedProfileResume?.employmentdetails.noticeperiod.lwd,
    reason: selectedProfileResume?.employmentdetails.noticeperiod.reason,
    jobcontinuity: selectedProfileResume?.employmentdetails.jobcontinuity,
    notworkingreason: selectedProfileResume?.employmentdetails.notworkingreason,
    currentctc: selectedProfileResume?.employmentdetails.currentctc.totalctc,
    ectc: myResumes?.[0]?.newemploymentdetails.ectc?.totalctc,
    preferredlocation: myResumes?.[0]?.newemploymentdetails.preferredlocation,
    locationchangereason: myResumes?.[0]?.newemploymentdetails.locationchangereason,
    aadharnumber: selectedProfileResume?.personaldetail.aadharid,
    uannumber: selectedProfileResume?.personaldetail.uan,
    dob: selectedProfileResume?.personaldetail.dob,
    gender: selectedProfileResume?.personaldetail.gender,
    skills:myResumes?.[0]?.profileskills,
    exptype:getExpType()
  };

  const completionPercentage = useMemo(() => {
    // 1. Define fields that are always visible in the JSX form
    let visibleKeys = [
      "skills",
      "exptype",
      "currentlocation",
      "preferredlocation",
      "locationchangereason",
      "maxdegree",
      "passoutyear",
      "college",
      "aadharnumber",
      "dob",
      "gender",
    ];

    // 2. Add fields visible only for Experienced candidates
    if (currentExptype !== "Fresher") {
      visibleKeys = visibleKeys.concat([
        "currentcompany",
        "designation",
        "totalexp",
        "noticeperiod",
        "negotiablenoticeperiod",
        "lwd",
        "currentctc",
        "ectc",
      ]);

      // 3. Add conditionally rendered field if they are not working
      if (notWorking) {
        visibleKeys.push("notworkingreason");
      }
    }

    const totalFields = visibleKeys.length;

    // 4. Calculate how many of the currently visible fields have valid values
    const filledFields = visibleKeys.filter((key) => {
      const value = appvalues[key];

      // Handle arrays (e.g., preferredlocation, which comes as an array)
      if (Array.isArray(value)) {
        return value.length > 0;
      }

      // Check if value exists (isn't null, undefined, or an empty string)
      // Note: 0 is considered a valid filled value (e.g., for notice period)
      return (
        value !== null && value !== undefined && String(value).trim() !== ""
      );
    }).length;

    return totalFields === 0
      ? 0
      : Math.round((filledFields / totalFields) * 100);
  }, [appvalues, currentExptype, notWorking]);
  // Added currentExptype and notWorking to the dependency array

  const handleOk = () => {
    const jasonValues = encodeApplicationJson(submittedValues);
    
    nuJobsUpdateCandidateProfile(jasonValues)
    message.success("Updated Profile");

    setConfirmLoading(false);
    setOpenConfirm(false);
    setIsEditMode(false);
  };

  const handleCancel = () => {
    setOpenConfirm(false);
  };
  return (
    <div className="nujobsprofile-summary-wrapper">
      <div className="profile-progress-wrapper">
        {" "}
        <Flex gap="small" wrap>
          <Progress type="circle" percent={completionPercentage} />
        </Flex>
        <div className="profile-progress-label">Profile Completion</div>
      </div>
      <div className="profile-creation-form-wrapper">
        <div className="header">
          {!isEditMode ? (
            <Button
              className="profile-creation-edit-button"
              onClick={() => setIsEditMode(true)}
              type="primary"
            >
              <img src={editIcon} alt="Edit" width="14" height="14" />
            </Button>
          ) : (
            <Button
              className="profile-creation-edit-button"
              onClick={() => setIsEditMode(false)}
            >
              <CloseOutlined />
            </Button>
          )}
        </div>

          <Form
            key={formKey}
            className="profile-creation-form"
            name="profile-creation-form"
            justify="start"
            layout="vertical"
            autoComplete="off"
            onFinish={ handleFormSubmit}
            initialValues={appvalues}
          >
            <div className="profile-section-title">👤 Skills/Expertise</div>
            <Form.Item
              rules={[{ required: true, message: 'Skills are required!' }]}
              className="jd-creation-field-item"
              label="My Skills"
              name="skills"
            >
              <Input
                disabled={!isEditMode}                
                className="jd-creation-input"
              />            
            </Form.Item>
            <div className="profile-section-title">💼 Professional Details</div>  
                <Form.Item
                  rules={[{ required: true, message: 'Please select an option!' }]}
                  name="exptype"
                  className="jd-creation-field-item"
                  label="Exp/Fresher"
                >
                  <Radio.Group
                    disabled={!isEditMode}
                    className="jd-creation-radio-wrapper-3"
                    name="exptype"
                    onChange={setExpTypeHandler}
                  >
                    <Radio className="radio-option" value={"Experienced"}>
                      Experienced
                    </Radio>
                    <Radio className="radio-option" value={"Fresher"}>
                      Fresher
                    </Radio>               
                  </Radio.Group>
            </Form.Item>            
            {
              currentExptype=="Fresher"
              ?<>
              </>
              :<>
                  <div className="triple-input-wrapper">
                    <Form.Item
                      rules={[{ required: true, message: 'Company name is required!' }]}
                      name="currentcompany"
                      className="jd-creation-field-item"
                      label="Current/Last Company"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="text"
                        className="jd-creation-input"
                      />
                    </Form.Item>                    
                    <Form.Item
                      rules={[{ required: true, message: 'Designation is required!' }]}
                      name="designation"
                      className="jd-creation-field-item"
                      label="Current/Last Designation"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="text"
                        className="jd-creation-input"
                      />
                    </Form.Item>

                    <Form.Item
                      rules={[{ required: true, message: 'Exp is required!' }]}
                      className="jd-creation-field-item"
                      label="Total Exp (Yrs)"
                      name="totalexp"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="number"
                        placeholder={"x.y"}
                        className="jd-creation-input"
                        name="totalexp"
                        onChange={(e) => setTotalExp(e.target.value)}
                      />
                    </Form.Item>
                  </div>
                  <div className="profile-section-title">💰 Employment & Salary</div>
                  <div className="triple-input-wrapper">
                    <Form.Item
                      rules={[
                          { required: true, message: 'Please specify!' }
                      ]}
                      className="jd-creation-field-item"
                      label="Official Notice Period (Days)"
                      name="noticeperiod"
                    >
                      <Select
                        disabled={!isEditMode}
                        placeholder="Please select"
                        className="jd-creation-dropdown"
                        options={[
                          { value: 0, label: 0 },
                          { value: 15, label: 15 },
                          { value: 30, label: 30 },
                          { value: 45, label: 45 },
                          { value: 60, label: 60 },
                          { value: 90, label: 90 },
                          { value: 120, label: 120 },
                          { value: 180, label: 180 },
                        ]}
                      />
                    </Form.Item>
                    <Form.Item
                      rules={[
                          { required: true, message: 'Please specify!' }
                      ]}              
                      className="jd-creation-field-item"
                      label="Notice Period (Days) (If Negotiable)"
                      name="negotiablenoticeperiod"
                    >
                      <Select
                        disabled={!isEditMode}
                        placeholder="Please select"
                        className="jd-creation-dropdown"
                        options={[
                          { value: 0, label: 0 },
                          { value: 5, label: 5 },
                          { value: 10, label: 10 },
                          { value: 15, label: 15 },
                          { value: 30, label: 30 },
                          { value: 45, label: 45 },
                          { value: 60, label: 60 },
                          { value: 90, label: 90 },
                          { value: 120, label: 120 },
                          { value: 180, label: 180 },
                        ]}
                      />
                    </Form.Item>
                    <Form.Item
                      className="jd-creation-field-item"
                      label="LWD"
                      name="lwd"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="text"
                        placeholder={"dd/mm/yyyy"}
                        className="jd-creation-input"
                      />
                    </Form.Item>                    
                  </div>
                  <div className="dual-input-wrapper">
                    <Form.Item
                      rules={[{ required: true, message: 'CTC is required!' }]}
                      name="currentctc"
                      className="jd-creation-field-item"
                      label="Current/Last CTC (LPA)"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="text"
                        className="jd-creation-input"
                      />
                    </Form.Item>    
                    <Form.Item
                      rules={[{ required: true, message: 'ECTC is required!' }]}
                      name="ectc"
                      className="jd-creation-field-item"
                      label="ECTC (LPA)"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="text"
                        className="jd-creation-input"
                      />
                    </Form.Item>                                                          
                  </div>                  
             

                  <div className="dual-input-wrapper">
                    {notWorking ? (
                      <>
                        <Form.Item
                          rules={[
                              { required: true, message: 'Please specify!' }
                          ]}     
                          className="jd-creation-field-item"
                          label="Currently Not Working Due to"
                          name="notworkingreason"
                        >
                          <Select
                            disabled={!isEditMode}
                            placeholder="Please select"
                            className="jd-creation-input"
                            options={reasonForNotWorkingFilter}
                          />
                        </Form.Item>                  
                      </>)
                      :<></>
                    }
                  </div>
              </> 
            }
                  <div className="profile-section-title">📍 Job Preferences</div>            
                  <div className="triple-input-wrapper">
                    <Form.Item
                      rules={[{ required: true, message: 'Location is required!' }]}
                      name="currentlocation"
                      className="jd-creation-field-item"
                      label="Current Location"
                    >
                      <Input
                        disabled={!isEditMode}
                        className="jd-creation-input"
                      />
                    </Form.Item>

                    <Form.Item
                      rules={[
                          { required: true, message: 'Please select Location!' }
                      ]}
                      name="preferredlocation"
                      className="jd-creation-field-item"
                      label="Preferred Locations"
                    >
                      <Select
                        disabled={!isEditMode}
                        mode="multiple"
                        allowClear
                        className="jd-creation-dropdown"
                        options={SUPPORTED_LOCATION}
                      />
                    </Form.Item>

                    <Form.Item
                      rules={[
                          { required: true, message: 'Please specify reason!' }
                      ]}
                      name="locationchangereason"
                      className="jd-creation-field-item"
                      label="Relocation Reason"
                    >
                      <Select
                        disabled={!isEditMode}
                        placeholder="Please Select"
                        className="jd-creation-dropdown"
                        options={[
                          { value: "NA", label: "NA" },
                          { value: "Partner Job", label: "Partner Job" },
                          {
                            value: "Family Member Lives there",
                            label: "Family Member Lives there",
                          },
                          { value: "Carrer Growth", label: "Carrer Growth" },
                          { value: "Other Reasons", label: "Other Reasons" },
                        ]}
                      />
                    </Form.Item>
                  </div>         
                  <div className="profile-section-title">🎓 Education</div>                     
                  <div className="triple-input-wrapper">
                    <Form.Item
                      rules={[{ required: true, message: 'Please select an option!' }]}
                      name="maxdegree"
                      className="jd-creation-field-item"
                      label="Max Degree"
                    >
                      <Select
                        disabled={!isEditMode}
                        placeholder="Please select"
                        className="jd-creation-dropdown"
                        options={EDUCATION_OPTIONS}
                      />
                    </Form.Item>
                    <Form.Item
                      name="passoutyear"
                      className="jd-creation-field-item"
                      label="Year of Passing"
                      rules={[{ required: true, message: 'Passout Year is requried' }]}
                    >
                      <Input
                        disabled={!isEditMode}
                        className="jd-creation-input"
                      />
                    </Form.Item>

                    <Form.Item
                      name="college"
                      className="jd-creation-field-item"
                      label="Uni/College"
                    >
                      <Select
                        disabled={!isEditMode}
                        placeholder="Please select"
                        className="jd-creation-dropdown"
                        options={[
                          { value: "Govt College", label: "Govt Colleges" },
                          { value: "Private College", label: "Private Colleges" },
                          { value: "AIIMS", label: "AIIMS" },
                          { value: "IIT", label: "IITs" },
                          { value: "IIM", label: "IIMs" },
                          { value: "REC", label: "RECs" },
                          { value: "Foreign", label: "Abroad" },
                          { value: "Others", label: "Others" },
                ]}
              />
            </Form.Item>
          </div>
          <div className="profile-section-title">🪪 Personal Details </div>
          <div className="triple-input-wrapper">
            <Form.Item
              name="aadharnumber"
              className="jd-creation-field-item"
              label="Aadhar Number"
            >
              <Input disabled={!isEditMode} className="jd-creation-input" />
            </Form.Item>
            <Form.Item
              name="dob"
              className="jd-creation-field-item"
              label="DoB"
            >
              <Input
                disabled={!isEditMode}
                className="jd-creation-input"
                placeholder="dd/mm/yyyy"
              />
            </Form.Item>
            <Form.Item
              name="gender"
              className="jd-creation-field-item"
              label=" Gender"
            >
              <Radio.Group
                disabled={!isEditMode}
                className="jd-creation-radio-wrapper"
              >
                <Radio className="radio-option" value={"Male"}>
                  Male
                </Radio>
                <Radio className="radio-option" value={"Female"}>
                  Female
                </Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          <Button
            style={{ width: "100%", height: "40px", fontWeight: "600" }}
            type="primary"
            disabled={!isEditMode}
            htmlType="submit"
          >
            Save Profile Details
          </Button>
        </Form>
      </div>

      <Modal
        title="Update Profile"
        centered
        open={openConfirm}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{modalText}</p>
      </Modal>

      <NuJobsSignedInFooter/>        
    </div>
  );
}
